export default __webpack_public_path__ + "static/media/Policy Stats-800X500.0a7f5a23.png";